'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSignals$0024 from "./presto.-Signals$.js";
var $p;
/** @constructor */
function $c_Lpresto_Mediator$$anon$18(request$2, bus$2, results$2, busy$4, tmp$2, outer) {
  this.b7F = null;
  this.b7E = null;
  this.a8t = null;
  this.a8s = null;
  this.b7G = null;
  this.b7F = request$2;
  this.b7E = bus$2;
  this.a8t = results$2;
  this.a8s = busy$4;
  this.b7G = tmp$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_Mediator$$anon$18 as $c_Lpresto_Mediator$$anon$18 };
$p = $c_Lpresto_Mediator$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Mediator$$anon$18;
/** @constructor */
function $h_Lpresto_Mediator$$anon$18() {
}
export { $h_Lpresto_Mediator$$anon$18 as $h_Lpresto_Mediator$$anon$18 };
$h_Lpresto_Mediator$$anon$18.prototype = $p;
$p.afL = (function() {
  return this.b7E.bp;
});
$p.a3D = (function() {
  return this.a8t.br;
});
$p.afT = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().ba(this.b7G, this.a8t);
});
$p.acq = (function() {
  return $j_presto$002e$002dSignals$0024.$m_Lpresto_Signals$().oT(this.a8s, this.b7F, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((_$11, _$12) => ((!(!_$11)) || _$12.mj()))));
});
$p.A3 = (function() {
  return this.a8s.R();
});
$p.cPR = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3D(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => _$13.db())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cMs = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cPR(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (!_$14.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cE8 = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3D(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => _$16.cwa().cPV().db())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.aeA = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cE8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$17) => (!_$17.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$18) => _$18.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_Mediator$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Mediator$$anon$18, "presto.Mediator$$anon$18", ({
  Mq: 1,
  Mr: 1
}));
export { $d_Lpresto_Mediator$$anon$18 as $d_Lpresto_Mediator$$anon$18 };
//# sourceMappingURL=presto.-Mediator$$anon$18.js.map
